<div class="layout-wrapper">
  <app-header (toggleSidebar)="toggleSidebar()"></app-header>
  <mat-sidenav-container class="layout-body">
    <mat-sidenav
      [opened]="sidebarOpen"
      [mode]="sidebarMode"
      class="sidebar"
      (openedChange)="sidebarOpen = $any($event)"
    >
      <app-sidebar-menu [menuConfig]="menuConfig"></app-sidebar-menu>
    </mat-sidenav>
    <mat-sidenav-content class="content">
      <div class="page-content">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>
